
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import ContactPage from "../pages/contact/page";
import CareersPage from "../pages/careers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
